import { memo } from 'react';

import { showActionSidebar } from 'ui/traveller-journey-builder/action-sidebar';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

import { JourneyStart } from './common';

type ActionType = 'journey_start';

export const Node = memo((node: TravellerJourneyNode<ActionType>) => {
  return (
    <NodeContainer node={node} hideTargetHandle disableClick>
      <JourneyStart node={node} cursor="pointer" onIconClick={() => showActionSidebar(node)} />
    </NodeContainer>
  );
});
